import Image, { ImageProps } from "next/image";
import { useState } from "react";

function ImageWithFallback({ src, fallBackSrc, style = "", ...rest }: Props) {
  const [imageError, setImageError] = useState(false);
  return (
    <Image
      src={imageError ? fallBackSrc : src}
      className={style}
      objectFit="cover"
      onError={() => setImageError(true)}
      {...rest}
    />
  );
}

type Props = {
  style?: string;
  fallBackSrc: string;
} & ImageProps;

export default ImageWithFallback;
